import { Simulator } from './simulation';

export enum UserRole {
  AccountManager = 'AccountManager',
  AreaDeveloper = 'AreaDeveloper',
  Author = 'Author',
  CourseManager = 'CourseManager',
  Instructor = 'Instructor',
  Member = 'Member',
  Student = 'Student',
}

// Current user
export interface Profile {
  avatar: string;
  companies: Company[];
  email?: string;
  joinedDate: Date;
  name: string;
  phone?: string;
  showRoutesMenu: boolean;
  simulators?: Simulator[];
  userId: string;
}

export enum Settings {
  canViewGroupSimulations = 'canViewGroupSimulations',
  kSimCargo = 'kSimCargo',
  kSimConnect = 'kSimConnect',
  kSimDP = 'kSimDP',
  kSimEngine = 'kSimEngine',
  kSimNavigation = 'kSimNavigation',
  marketing = 'marketing',
  operational = 'operational',
  systemService = 'systemService',
}

export interface CompanySettings {
  [Settings.canViewGroupSimulations]: boolean;
  [Settings.kSimCargo]: boolean;
  [Settings.kSimConnect]: boolean;
  [Settings.kSimDP]: boolean;
  [Settings.kSimEngine]: boolean;
  [Settings.kSimNavigation]: boolean;
  [Settings.marketing]: boolean;
  [Settings.operational]: boolean;
  [Settings.systemService]: boolean;
}

export interface Company {
  companyId: string;
  isHomeCompany?: boolean;
  name: string;
  roles: UserRole[];
  features: string[];
  settings: CompanySettings;
}

export interface User {
  avatar?: string;
  email: string;
  id: string;
  name: string;
  roles: UserRole[];
  userProfileId: string;
}

// This is just a collection of userIds to use as preset when assigning users to an exercise.
// The groupId assignment is not stored.
export interface UserGroup {
  id: string;
  name: string;
  userIds: string[];
}
